import { render } from "./FinalContent.vue?vue&type=template&id=3143bb76&scoped=true"
import script from "./FinalContent.vue?vue&type=script&lang=ts"
export * from "./FinalContent.vue?vue&type=script&lang=ts"

import "./FinalContent.vue?vue&type=style&index=0&id=3143bb76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3143bb76"

export default script